/**
 * Date formatting helpers — NASH convention is dd/mm/yyyy throughout.
 *
 * Use formatDate(date) for date-only display, formatDateTime(date) for
 * date + time. Both accept a Date or an ISO 8601 string. Returns an
 * empty string for null/undefined/invalid inputs so callers don't have
 * to guard.
 */

const DATE_FORMATTER = new Intl.DateTimeFormat('en-NZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATETIME_FORMATTER = new Intl.DateTimeFormat('en-NZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const TIME_FORMATTER = new Intl.DateTimeFormat('en-NZ', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

function toDate(input: Date | string | null | undefined): Date | null {
  if (input == null) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(input: Date | string | null | undefined): string {
  const d = toDate(input);
  return d ? DATE_FORMATTER.format(d) : '';
}

export function formatDateTime(input: Date | string | null | undefined): string {
  const d = toDate(input);
  return d ? DATETIME_FORMATTER.format(d) : '';
}

export function formatTime(input: Date | string | null | undefined): string {
  const d = toDate(input);
  return d ? TIME_FORMATTER.format(d) : '';
}
